import { useState,useRef,useEffect } from "react";
import { Button, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList, Box } from "@mui/material";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

const ExportMenu = ({ disabled, exportReportFn, files, title }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleClose = (event, file, triggerExport) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
    if (triggerExport) {
      exportReportFn(file);
    }
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);
  return (
    <>
      <Button
        className="costum-export-btn"
        variant="outlined"
        size="small"
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        color="primary"
        disabled={disabled}
      >
        <SaveAltIcon sx={{fontSize: { xs: "small", md: "medium" }}}/>
        {title ? title : "Export"}
      </Button>
      <Popper
        placement="bottom-end"
        style={{ zIndex: "9" }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="menu-list-grow"
                  onKeyDown={handleListKeyDown}
                  className="menu-list-item"
                  // sx={{
                  //   boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  //   borderRadius: "5px",
                  //   backgroundColor: "#fff",
                  //   display: "flex",
                  //   width: "100px",
                  //   flexDirection: "column",
                  // }}
                >
                  {files.map((file, index) => (
                    <MenuItem
                      key={index}
                      onClick={(event) =>
                        handleClose(event, file, "triggerExport")
                      }
                      sx={{
                        fontSize: "16px",
                        cursor: "pointer",
                        color: "#000",
                        "&:hover": {
                          backgroundColor: " #E6EBFB",
                        },
                      }}
                    >
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {file.extension === "pdf" ? (
                          <PictureAsPdfIcon />
                        ) : file.extension === "docx" ? (
                          <InsertDriveFileIcon />
                        ) : (
                          <DescriptionIcon />
                        )}
                        {file.title}
                      </Box>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default ExportMenu;
